import { Button, Stack, Typography } from "@compass/core";
import { Permission, PermissionAction } from "generated/openApi";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import { collegePageRoute } from "../CollegePage/CollegePage";

export const CollegeListPageHeader = (props: { rootPermission: Permission; handle: string }) => {
  const navigate = useNavigate();

  return (
    <Stack direction="row" justifyContent="space-between">
      <Typography variant="inherit">{props.handle}</Typography>

      <Stack direction="row" alignItems="center" spacing="sm">
        {isAuthorized(props.rootPermission, PermissionAction.Create) && (
          <Button onClick={() => navigate(collegePageRoute.getPath({ id: 0, crudMode: "edit" }))} variant="outlined">
            + New
          </Button>
        )}
      </Stack>
    </Stack>
  );
};
